/** Debe coincidir con src/portal-health/portal-health.constants.ts */
export const PORTAL_HEALTH_ALLOWED_EMAILS = [
  'dieter.spee@smartcfo.cl',
  'joaquin.vila@smartcfo.cl',
  'daniela.gonzalez@smartcfo.cl',
  'nicolas.pacheco@smartcfo.cl',
  'data.governance@smartcfo.cl',
]

export function getSessionEmail(token = localStorage.getItem('token')) {
  if (!token) return localStorage.getItem('userEmail') || ''
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return localStorage.getItem('userEmail') || ''
    const payload = JSON.parse(atob(parts[1]))
    return (payload.email || localStorage.getItem('userEmail') || '').trim()
  } catch {
    return localStorage.getItem('userEmail') || ''
  }
}

export function canAccessPortalHealth(email = getSessionEmail()) {
  if (!email) return false
  return PORTAL_HEALTH_ALLOWED_EMAILS.includes(String(email).trim().toLowerCase())
}
